import { sortWeekDaysByDateAsc } from "./weekDays";

/**
 * Tlačový / náhľadový dokument: str. 1 = týždenné menu (catering tabuľka),
 * str. 2 = zoznam alergénov. Prevzaté z referenčného balíka lunch-menu-print.
 * Zmena oproti originálu: logo sa posiela ako `logoSrc` prop (namiesto pevného LOGO_SRC),
 * a wrapper používa len triedu `lmp-document` (layout je v CSS, projekt nemá Tailwind).
 */

function visibleItems(items) {
  if (!Array.isArray(items)) {
    return [];
  }
  return items.filter((meal) => typeof meal === "string" && meal.trim() !== "");
}

export function LunchMenuPrintView({
  week,
  brandName,
  sheetTitle,
  soupLabel,
  printCopy,
  logoSrc,
}) {
  const days = sortWeekDaysByDateAsc(Array.isArray(week?.days) ? week.days : []);
  const weekRange = typeof week?.week === "string" ? week.week : "";
  const title =
    typeof sheetTitle === "string" && sheetTitle.trim()
      ? sheetTitle.trim()
      : "Daily menu";

  const infoHeading =
    typeof printCopy?.infoHeading === "string" ? printCopy.infoHeading : "";
  const allergenHeading =
    typeof printCopy?.allergenHeading === "string"
      ? printCopy.allergenHeading
      : "";
  const paragraphs = Array.isArray(printCopy?.infoParagraphs)
    ? printCopy.infoParagraphs
    : [];
  const allergens = Array.isArray(printCopy?.allergens)
    ? printCopy.allergens
    : [];

  return (
    <div className="lmp-document">
      <section className="lmp-page-one" aria-label={title}>
        <header className="lmp-header">
          {logoSrc ? (
            <img src={logoSrc} alt="" width={120} height={120} />
          ) : null}
          <div className="lmp-header-text">
            <div className="lmp-brand-line">{brandName}</div>
            <div className="lmp-title-week-line">
              <span className="lmp-sheet-title">{title}</span>
              {weekRange ? (
                <span className="lmp-week-range"> · {weekRange}</span>
              ) : null}
            </div>
          </div>
        </header>

        <table className="lmp-table">
          {days.map((day) => {
            const soups = Array.isArray(day?.soups) ? day.soups : [];
            const items = visibleItems(day?.items);
            const dayKey = `${day?.name ?? ""}-${day?.date ?? ""}`;

            return (
              <tbody key={dayKey} className="lmp-day-group">
                <tr className="lmp-day-title-row">
                  <td colSpan={2}>
                    <span>{day?.name}</span>
                    {day?.date ? (
                      <span className="lmp-day-date">· {day.date}</span>
                    ) : null}
                  </td>
                </tr>
                {soups.length > 0 ? (
                  <tr>
                    <td className="lmp-label">{soupLabel}</td>
                    <td>
                      {soups.length === 1 ? (
                        <span className="lmp-soup-single">{soups[0]}</span>
                      ) : (
                        <ul className="lmp-soup-list">
                          {soups.map((line, idx) => (
                            <li key={idx}>{line}</li>
                          ))}
                        </ul>
                      )}
                    </td>
                  </tr>
                ) : null}
                {items.map((item, idx) => (
                  <tr key={`${item}-${idx}`}>
                    <td className="lmp-num">{idx + 1}.</td>
                    <td>{item}</td>
                  </tr>
                ))}
              </tbody>
            );
          })}
        </table>
      </section>

      <section
        className="lmp-page-two"
        aria-label={allergenHeading || infoHeading}
      >
        {infoHeading ? (
          <h2 className="lmp-allergen-title">{infoHeading}</h2>
        ) : null}
        {paragraphs.map((p, i) =>
          typeof p === "string" && p.trim() ? (
            <p key={i} className="lmp-info-text">
              {p}
            </p>
          ) : null,
        )}
        {allergenHeading ? (
          <h3 className="lmp-allergen-subtitle">{allergenHeading}</h3>
        ) : null}
        {allergens.length > 0 ? (
          <ol className="lmp-allergen-list">
            {allergens.map((row) => {
              const code = row?.code != null ? String(row.code) : "";
              const text = typeof row?.text === "string" ? row.text : "";
              if (!text) {
                return null;
              }
              return (
                <li key={code || text}>
                  <span className="lmp-allergen-code">{code}.</span>
                  <span>{text}</span>
                </li>
              );
            })}
          </ol>
        ) : null}
      </section>
    </div>
  );
}
